import { makeStyles } from '@material-ui/core';
import hexToRgb from '../../../helpers/ui/coloringHelper';

const useStyles = makeStyles((theme) => {
  const commonSuggestedCountry = {
    color: theme.palette.primary.main,
    fontSize: '1rem',
    marginRight: '0.5rem',
    height: 36,
    marginTop: '0.3rem',
    padding: '0 16px',
    width: 'fit-content',
    borderRadius: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
  };

  return {
    autocompleteRoot: {
      '& .MuiAutocomplete-inputRoot': {
        padding: 4,
        paddingTop: theme.spacing(1.2),
      },
    },
    inputLabel: {
      transform: 'translate(14px, 12px) scale(1)',
    },
    paper: {
      display: 'flex',
      fontSize: '1rem',
      border: `1px solid ${theme.palette.gray.efesGray}`,
      boxShadow: `0px 20px 20px ${theme.palette.gray.boxShadow}`,
      backgroundColor: theme.palette.white.main,
    },
    option: {
      whiteSpace: 'normal',
      wordWrap: 'break-word',
    },
    textContainer: {
      backgroundColor: theme.palette.white.efesBackgroundLight,
      alignItems: 'center',
      overflow: 'hidden',
      transition: 'max-height .2s ease-in-out',
      maxHeight: 0,
    },
    textContainerOpen: {
      maxHeight: 1000,
    },
    container: {
      alignItems: 'center',
      backgroundColor: theme.palette.white.efesBackgroundLight,
      marginTop: '1rem',
      paddingBottom: 20,
    },
    mainButton: {
      borderRadius: '0.3rem',
      textTransform: 'none',
      borderColor: theme.palette.gray.efesBorder,
      height: 46,
      '&:active': {
        backgroundColor: theme.palette.primary.pressed,
        color: theme.palette.white.main,
      },
    },
    active: {
      backgroundColor: theme.palette.primary.pressed,
      '&:hover': {
        backgroundColor: theme.palette.primary.pressed,
        color: theme.palette.white.main,
      },
    },
    text: {
      color: theme.palette.black.main,
      textAlign: 'justify',
      paddingBottom: 20,
      margin: 0,
      width: '100%',
    },
    headingWrapper: {
      textAlign: 'right',
    },
    buttonsWrapper: {
      textAlign: 'center',
      overflow: 'hidden',
      transition: 'max-height .2s ease-in-out',
      maxHeight: 0,
      justifyContent: 'space-between',
    },
    buttonsWrapperOpen: {
      maxHeight: '1000px',
    },
    iconButton: {
      width: '1.5rem',
      textAlign: 'center',
      height: '1.5rem',
      borderRadius: '50%',
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.white.main,
      transition: 'transform .2s ease-in-out',
      cursor: 'pointer',
      '&:hover': {
        border: `1px solid ${theme.palette.primary.hover}`,
        color: theme.palette.primary.hover,
      },
    },
    packageDesktopText: {
      color: theme.palette.black.main,
      textAlign: 'justify',
      paddingTop: 25,
      width: '100%',
    },
    openPackagesFormControl: {
      marginBottom: '1rem',
      marginTop: '1rem',
      [theme.breakpoints.down('sm')]: {
        marginTop: '2rem',
      },
    },
    textInfo: {
      color: theme.palette.primary.main,
    },
    clearIcon: {
      height: 24,
      width: 24,
      color: theme.palette.primary.main,
      paddingLeft: '0.5rem',
      '&:hover': {
        color: theme.palette.primary.main,
      },
    },
    gridItem: {
      padding: '.5rem .5rem 0.5rem 0',
    },
    suggestions: {
      marginTop: '.7rem',
      display: 'flex',
      flexWrap: 'wrap',
    },
    suggestedCountry: {
      ...commonSuggestedCountry,
      backgroundColor: `rgba(${hexToRgb(theme.palette.primary.main)}, 0.1)`,
      '&:hover': {
        backgroundColor: `rgba(${hexToRgb(theme.palette.primary.main)}, 0.2)`,
      },
    },
    icon: {
      color: theme.palette.black.main,
    },
    removeIcon: {
      color: theme.palette.black.main,
      fontSize: 15,
    },
    suggestedSelectedCountry: {
      ...commonSuggestedCountry,
      backgroundColor: `rgba(${hexToRgb(theme.palette.primary.main)}, 0.2)`,
      '&:hover': {
        backgroundColor: `rgba(${hexToRgb(theme.palette.primary.main)}, 0.2)`,
      },
    },
  };
});

export default useStyles;
